import React from "react";
import ApiBilling from "../../code/api/ApiBilling";
import AuthAdminUserModel from '../../code/models/AuthAdminUserModel';
import ButtonConfirm, { ButtonConfirmSize } from "../ButtonConfirm";
import Toaster from "../Toaster";

interface IAdminMonthlyBilling {
    adminUser: AuthAdminUserModel;
}

export default function AdminMonthlyBilling({ adminUser }: IAdminMonthlyBilling) {
    const [toastMessage, setToastMessage] = React.useState<string>("");

    function handleRunMonthlyBilling(confirm: boolean) {
        if (!confirm) return;
        ApiBilling.runMonthlyBilling().then((success) => {
            if (success) {
                setToastMessage("Monthly billing has been requested to run.");
            }
        });
    }


    return (
        <React.Fragment>
            <main className="container">
                <div className="row pad-top-10">
                    <div className="col-2 text-start fs-3">Monthly Billing</div>
                    <div className="col-2"><ButtonConfirm buttonText="Run Monthly Billing" confirmMessage="Run Monthly Billing?"
                        confirmTitle="Billing" onConfirm={handleRunMonthlyBilling} enabled={true} buttonSize={ButtonConfirmSize.Normal} cssClass={""} /></div>
                </div>
            </main>
            <Toaster title="Billing" subtitle="Monthly Billing" message={toastMessage} key={"monthlybillingtoast"} />
        </React.Fragment>
    )
}
